import UploadPDF from '@/components/UploadPDF';
import { useUploadPdf } from '@/components/UploadPDF/hooks';

import { DailyLimitModalListener } from '../MyDocuments/DailyLimitModal';

function NewDocument() {
	const { handleDrop, loading } = useUploadPdf();

	return (
		<>
			<div className="bg-grey-100 py-10 md:py-32">
				<div className="container">
					<UploadPDF
						onDrop={handleDrop}
						loading={loading}
						className="container"
					/>
				</div>
			</div>

			<DailyLimitModalListener />
		</>
	);
}

export default NewDocument;
